import styled from "@emotion/styled";
import { LdButton, LdModal } from "@liquid/react";

import { pxToRem } from "@src/utils";

const FooterButton = styled(LdButton)`
  min-width: ${pxToRem(300)};

  ::part(button) {
    gap: var(--ld-button-gap-lg);
  }
`;

const StyledPanelContainer = styled.div`
  background-color: var(--ld-col-wht);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const StyledAnchor = styled(LdButton)`
  cursor: pointer;
  color: #0e68ae;
  text-decoration: underline;
`;

const StyledModal = styled(LdModal)<{
  width?: string;
  padding?: string;
  height?: string;
}>`
  ::part(dialog) {
    min-width: ${({ width }) => (width ? width : pxToRem(900))};
    max-width: 98%;
    word-wrap: break-word;
    height: ${({ height }) => (height ? height : "auto")};
    min-height: auto;
  }

  ::part(header) {
    background-color: transparent;
    padding-block-end: 0;
  }

  ::part(footer) {
    background-color: transparent;
  }

  ::part(footer) {
    display: flex;
    padding-block-start: 0;
  }

  ::part(content) {
    display: flex;
    flex-direction: column;
    gap: ${pxToRem(40)};
    padding: ${({ padding }) =>
      padding ? padding : ` ${pxToRem(10)} ${pxToRem(32)} ${pxToRem(50)}`};
  }

  ld-button {
    padding-bottom: ${pxToRem(32)};
    width: auto;
    flex: 2;
    margin: 0;
  }

  ld-typo[slot="header"] {
    padding: 10px 5px;
  }
`;

const StyledImg = styled.img`
  width: 100%;
`;

export {
  FooterButton,
  StyledPanelContainer,
  StyledAnchor,
  StyledModal,
  StyledImg,
};
